// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/$location._c.location/route.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/$location._c.location/route.tsx");
}
// REMIX HMR END

import { locationExample } from '@commural/shared-resources/schemas/business/Location.example';
import { useLoaderDataWithCache } from '@commural/shared-resources/utils/common';
import clsx from 'clsx';
import { useLocale } from 'remix-i18next';
import invariant from 'tiny-invariant';
import { Card } from '~/components/Card';
import { ScrollView } from '~/components/ScrollView';
import { getCapitalized } from '~/utils.server';
import { GoogleMapPlaceIdComponent } from './GoogleMapLocationIdComponent';
import cn from './Location.module.css';
const TITLE = 'location information';
export async function loader({
  request,
  context
}) {
  const title = await getCapitalized(TITLE, request, context);
  const location = locationExample;
  return {
    title,
    location,
    googleMapApiKey: context.env.GOOGLE_MAP_API_KEY
  };
}
export const meta = ({
  data
}) => {
  invariant(data?.title, 'title is required');
  return [{
    title: data.title
  }];
};
export const handle = {
  title: TITLE
};
export default function Index() {
  _s();
  const {
    location,
    googleMapApiKey
  } = useLoaderDataWithCache();
  const locale = useLocale();
  return <>
      <button className={cn.PreviewButton}>Preview</button>
      <ScrollView>
        <section className={clsx('masonry', cn.Location)}>
          <Card className={cn.Card}>
            <h1>Location Name</h1>
            <p>{location.name}</p>
            <h1>Description</h1>
            <p>{location.description}</p>
            <h1>Owner's Voice</h1>
            <p>{location.ownersVoice}</p>
          </Card>

          <Card className={cn.Card}>
            <h1>Location Image</h1>
            <p>
              <img src={location.bannerURL} alt="location" />
            </p>
          </Card>

          <Card className={cn.Card}>
            <h1>Address</h1>
            <p>{location.address}</p>
          </Card>

          <Card className={cn.Card}>
            <h1>Email</h1>
            <p>{location.email}</p>
          </Card>

          <Card className={cn.Card}>
            <h1>Phone Number</h1>
            <p>{location.phoneNumber}</p>
          </Card>

          <Card className={cn.Card}>
            <h1>Business Hours</h1>
            <p>{location.businessHours}</p>
            <h1>Regular Holiday</h1>
            <p>{location.regularHoliday}</p>
          </Card>

          <Card className={cn.Card}>
            <h1>Access</h1>
            <p>{location.access}</p>
            <h1>Google Map</h1>
            <GoogleMapPlaceIdComponent language={locale} placeId={location.googleMapPlaceId} apiKey={googleMapApiKey} onSelect={v => {
            console.log(v);
          }} />

          </Card>
        </section>
      </ScrollView>
    </>;
}
_s(Index, "I6jeO0HPYkUnrAxrVC0N43PTyk0=", false, function () {
  return [useLoaderDataWithCache, useLocale];
});
_c = Index;
var _c;
$RefreshReg$(_c, "Index");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;